import { Grid, Icon, Typography }      from "@gupshup-frontend/gupshup-ts-components";

import {
  PREVIEW_REGEX,
  PRODUCT_MESSAGE,
  TEMPLATE_PREVIEW_DATA_TESTID,
}                                      from "./constant";
import styles                          from "./style.module.css";

const ProductMessage = ({ content = "", isCatalogMessage = false }) => {

  return (
    <Grid className = {styles.productPanel}>
      <Grid className = {styles.productIcon}>
        <Icon
          size       = {36}
          alt        = "Product Message Icon"
          customPath = {PRODUCT_MESSAGE.ICONPATH}
        />
      </Grid>
      <Grid className = {styles.productMessage} >
        <Typography noWrap variant = "caption" fontWeight = {500} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.MARKETING_HEADER}>
          {isCatalogMessage ? PRODUCT_MESSAGE.CATALOG_HEADER : content?.replace(PREVIEW_REGEX.BRACKET_REGEX, '')}
        </Typography>
        <Typography noWrap className = {styles.productSubHeader} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.MARKETING_SUB_HEADER}>
          {isCatalogMessage ? PRODUCT_MESSAGE.CATALOG_SUBHEADER : PRODUCT_MESSAGE.MESSAGE}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ProductMessage;
